/**
 * Carries a number the user typed in the chat to the verification screen's field.
 *
 * `sessionStorage` rather than a query param, because a URL is reported to every analytics tag on the
 * page. Carried verbatim: what belongs in that field is the agent's call.
 *
 * Windowed, because two paths write without anything reading — the step already being open, and the user
 * closing before it opens — and the value would otherwise seed a verification they start themselves later.
 */
const KEY = 'symphony-phone-prefill';
const GOOD_FOR_MS = 5 * 60 * 1000;

export function savePhonePrefill(value: string): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ value, at: Date.now() }));
  } catch {
    // A blocked or full store just means the field opens empty.
  }
}

/** Reads and clears. Null for nothing stashed, or a stash past its window. */
export function readPhonePrefill(): string | null {
  let stored: string | null = null;
  try {
    stored = sessionStorage.getItem(KEY);
    if (stored) sessionStorage.removeItem(KEY);
  } catch {
    return null;
  }
  if (!stored) return null;
  try {
    const { value, at } = JSON.parse(stored) as { value?: string; at?: number };
    return value && typeof at === 'number' && Date.now() - at <= GOOD_FOR_MS ? value : null;
  } catch {
    return null;
  }
}
